import { render, staticRenderFns } from "./AssignMap.vue?vue&type=template&id=21fe65b8&scoped=true"
import script from "./AssignMap.vue?vue&type=script&lang=js"
export * from "./AssignMap.vue?vue&type=script&lang=js"
import style0 from "./AssignMap.vue?vue&type=style&index=0&id=21fe65b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fe65b8",
  null
  
)

export default component.exports